<template lang="pug">
.v-vacancy-card.vacancy-card(v-if="data")
	.vacancy-card__title(v-if="data.title" @click="open = !open") {{ data.title }}
	.vacancy-card__subtitle(v-if="data.subtitle" ) {{ data.subtitle }}
	.vacancy-card__info(v-if="data.info" )
		.vacancy-card__info-item(v-for="(item, index) in data.info" :key="index")
			img.vacancy-card__info-image(
				v-if="item.image"
				:src="item.image?.src"
				:alt="item.image?.alt")
			.vacancy-card__info-text(v-if="item.text") {{ item.text }}
	v-collapse(:open="open")
		.vacancy-card__collapse
				.vacancy-card__description(v-if="data.description" v-html="data.description" )
				.vacancy-card__actions
					button.vacancy-card__button.btn.btn--primary(
							v-if="data.button"
							@click="openModal")
						| {{ data.button?.text }}
					a.vacancy-card__link.btn.btn--gray(
							v-if="data.link"
							:href="data.link?.href"
							download )
						| {{ data.link?.text }}



</template>

<script>
import sourceMixin from './mixins/v-mixin-source.vue';

export default {

	mixins: [
		sourceMixin
	],

	emits: [
		'open-form'
	],

	data() {
		return {
			data: null,
			open: false
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		},

		openModal() {
			this.$emit('open-form', this.data?.id)
		}
	}
}

</script>